import { getConfigExtraInfo } from "../helpers/utils";

export default function(app, live) {
  return function(chatbot) {
    chatbot.subscriptions.onStartConversation(function (conversationData, next) {
      window.chatbot = chatbot;
      let horario = {};

      let variableList = [
        {
          name: "livechat",
          value: live
        },
        {
          name: 'federatedBotProfile',
          value: app.appConfig.instance === 'cl' ? 2 : 4
        }
      ];
      chatbot.api.addMultipleVariables(variableList);

      getConfigExtraInfo(chatbot, function (config) {
        if(!config) return;
        app.appConfig.instance === 'cl'
         ? horario = config.horarioChile
         : horario = config.horarioPeru
        localStorage.setItem('working_hours_start', horario.inicio);
        localStorage.setItem('working_hours_end', horario.fin);
      })

      return next(conversationData);
    });
  }
}
